export default "/images/21a9a67bf1469d6a574a24204ec27fcf.png";